export const hasTooltipLinks = (extra) => (extra?.sections ?? []).some(({ rows }) => rows?.some(({ href }) => href));
